import { Skeleton } from '@mui/material';
import { CerebroDrawer, CerebroHeading, CerebroText } from '../../shared/components';
import { useMatchingUnavailableReasonsQuery } from '../../shared/hooks';
import { TrancheEvaluation } from '../../shared/models';
import { EnumUtils } from '../../shared/utils';
import { getStructureTrancheValue, getTier1BankTypeValue } from '../../shared/utils/matching';

interface UnavailableReasonDrawerProps {
	dealGuid: string;
	tranche: TrancheEvaluation | null;
	onClose: () => void;
}

export const UnavailableReasonDrawer: React.FC<UnavailableReasonDrawerProps> = ({ dealGuid, tranche, onClose }) => {
	const open = tranche != null;
	const structureTranche = getStructureTrancheValue(tranche?.structureTranche);
	const tier1BankType = getTier1BankTypeValue(tranche?.tier1BankType);

	const query = useMatchingUnavailableReasonsQuery(dealGuid, structureTranche, tier1BankType, { enabled: open });

	return (
		<CerebroDrawer open={open} onClose={onClose}>
			<CerebroHeading>{EnumUtils.GetStructureTrancheDescription(tranche?.structureTranche)}</CerebroHeading>
			<CerebroHeading size="h3">{EnumUtils.GetTier1BankTypeDescription(tranche?.tier1BankType)}</CerebroHeading>

			{(query.isLoading || query.isFetching) && (
				<>
					<Skeleton height={60} />
					<Skeleton height={60} />
				</>
			)}

			{query.isSuccess && (
				<CerebroText>
					<ul>
						{query.data.map((reason, index) => (
							<li key={`${reason}-${index}`}>{reason}</li>
						))}
					</ul>
				</CerebroText>
			)}
		</CerebroDrawer>
	);
};
